const flattenFaqLocale = (faqMap) =>
  Object.entries(faqMap).reduce((acc, [faqKey, content]) => {
    acc[`lukkey.faq.${faqKey}.question`] = content.question;

    (content.paragraphs || []).forEach((paragraph, index) => {
      acc[`lukkey.faq.${faqKey}.paragraph${index + 1}`] = paragraph;
    });

    (content.bullets || []).forEach((bullet, index) => {
      acc[`lukkey.faq.${faqKey}.bullet${index + 1}`] = bullet;
    });

    return acc;
  }, {});

const faqLocales = {
  en: {
    faq1: {
      question: "What makes LUKKEY different from other hardware wallets?",
      paragraphs: [
        "LUKKEY is designed to combine strong security with everyday usability.",
        "LUKKEY aims to make self-custody safer and easier for everyone.",
      ],
      bullets: [
        "EAL6+ secure element chip for advanced key protection",
        "Fingerprint authentication for fast and secure access",
        "Three independent wallets on one device for asset separation and privacy",
        "Cold signing architecture to keep private keys fully offline",
      ],
    },
    faq2: {
      question: "Is LUKKEY open source?",
      paragraphs: [
        "Yes. LUKKEY is open source, allowing the community to review the code and carry out independent security audits.",
        "We believe a hardware wallet should be transparent and verifiable, and open source is a core part of building that trust.",
      ],
    },
    faq3: {
      question: "What does the EAL6+ secure element do?",
      paragraphs: [
        "The EAL6+ secure element is a specialized chip designed to protect sensitive cryptographic data.",
        "It securely stores your private keys and performs cryptographic operations inside a tamper-resistant environment, protecting your assets from physical and digital attacks.",
        "This level of security certification is commonly used in bank cards, passports, and high-security devices.",
      ],
    },
    faq4: {
      question: "Can I create three independent wallets on one device?",
      paragraphs: [
        "Yes.",
        "LUKKEY allows you to create three completely independent wallets on a single device, each with its own private keys and recovery phrase.",
        "Each wallet operates independently and securely.",
      ],
      bullets: [
        "Separate long-term holdings and daily funds",
        "Manage different portfolios",
        "Create hidden or decoy wallets for additional privacy",
      ],
    },
    faq5: {
      question: "What happens if I lose the device?",
      paragraphs: [
        "Your crypto assets are not stored on the device, but on the blockchain.",
        "When setting up LUKKEY, you will generate a recovery phrase used to restore your wallet.",
        "LUKKEY also supports an NFC backup card, providing a convenient way to securely store your recovery information.",
        "If your device is lost or damaged, you can restore your wallet using your recovery phrase or NFC backup card.",
        "As long as your backup is safe, your funds remain safe.",
      ],
    },
    faq6: {
      question: "What does the $1 reservation include?",
      paragraphs: [
        "The $1 reservation secures your early-bird eligibility and places you on the priority list before the crowdfunding launch.",
        "Before the public launch, you will receive early notification and the full reservation benefits.",
      ],
      bullets: [
        "$20 off the early-bird price",
        "Get the launch email first and early access to the crowdfunding page",
        "Priority shipping",
        "VIP community access",
        "Limited-edition NFC backup card and exclusive IP gift",
      ],
    },
    faq7: {
      question: "When will LUKKEY launch on Kickstarter?",
      paragraphs: [
        "LUKKEY is planned to launch on Kickstarter in 2026.",
        "All reservation holders will receive early access and notification before the public launch.",
      ],
    },
    faq8: {
      question: "Which assets will LUKKEY support?",
      paragraphs: [
        "LUKKEY supports 30+ blockchain networks and thousands of cryptocurrencies and NFT assets.",
        "Users can securely manage both cryptocurrencies and NFTs on one device.",
        "More networks and assets will continue to be added through firmware and app updates.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "and many more",
      ],
    },
  },
  fr: {
    faq1: {
      question:
        "Qu'est-ce qui différencie LUKKEY des autres hardware wallets ?",
      paragraphs: [
        "LUKKEY est conçu pour allier une sécurité forte à une utilisation simple au quotidien.",
        "LUKKEY vise à rendre l'auto-conservation plus sûre et plus accessible pour tous.",
      ],
      bullets: [
        "Puce Secure Element EAL6+ pour une protection avancée des clés",
        "Authentification par empreinte digitale pour un accès rapide et sûr",
        "Trois wallets indépendants sur un seul appareil pour la séparation des actifs et la confidentialité",
        "Architecture de signature à froid pour garder les clés privées totalement hors ligne",
      ],
    },
    faq2: {
      question: "LUKKEY est-il open source ?",
      paragraphs: [
        "Oui. LUKKEY est open source, ce qui permet à la communauté de relire le code et d'effectuer des audits de sécurité indépendants.",
        "Nous pensons qu'un hardware wallet doit être transparent et vérifiable, et l'open source est un élément central de cette confiance.",
      ],
    },
    faq3: {
      question: "À quoi sert le Secure Element EAL6+ ?",
      paragraphs: [
        "Le Secure Element EAL6+ est une puce spécialisée conçue pour protéger les données cryptographiques sensibles.",
        "Il stocke vos clés privées de manière sécurisée et exécute les opérations cryptographiques dans un environnement résistant aux manipulations, afin de protéger vos actifs contre les attaques physiques et numériques.",
        "Ce niveau de certification de sécurité est couramment utilisé dans les cartes bancaires, les passeports et les appareils à haute sécurité.",
      ],
    },
    faq4: {
      question: "Puis-je créer trois wallets indépendants sur un seul appareil ?",
      paragraphs: [
        "Oui.",
        "LUKKEY vous permet de créer trois wallets totalement indépendants sur un seul appareil, chacun avec ses propres clés privées et sa propre phrase de récupération.",
        "Chaque wallet fonctionne de façon indépendante et sécurisée.",
      ],
      bullets: [
        "Séparer les fonds de long terme et les dépenses quotidiennes",
        "Gérer différents portefeuilles",
        "Créer des wallets cachés ou leurres pour plus de confidentialité",
      ],
    },
    faq5: {
      question: "Que se passe-t-il si je perds l'appareil ?",
      paragraphs: [
        "Vos crypto-actifs ne sont pas stockés sur l'appareil, mais sur la blockchain.",
        "Lors de la configuration de LUKKEY, vous générez une phrase de récupération utilisée pour restaurer votre wallet.",
        "LUKKEY prend également en charge une carte de sauvegarde NFC, offrant un moyen pratique de stocker vos informations de récupération en toute sécurité.",
        "Si votre appareil est perdu ou endommagé, vous pouvez restaurer votre wallet à l'aide de votre phrase de récupération ou de la carte de sauvegarde NFC.",
        "Tant que votre sauvegarde reste en sécurité, vos fonds restent en sécurité.",
      ],
    },
    faq6: {
      question: "Que comprend la réservation à 1 $ ?",
      paragraphs: [
        "La réservation à 1 $ vous permet de conserver votre éligibilité early bird et de rejoindre la liste prioritaire avant le lancement du financement participatif.",
        "Avant l'ouverture publique, vous recevrez une notification anticipée et l'ensemble des avantages de réservation.",
      ],
      bullets: [
        "20 $ de réduction sur le tarif early bird",
        "Recevoir l'e-mail de lancement en premier et accéder plus tôt à la page de crowdfunding",
        "Expédition prioritaire",
        "Accès à la communauté VIP",
        "Carte de sauvegarde NFC en édition limitée et cadeau IP exclusif",
      ],
    },
    faq7: {
      question: "Quand LUKKEY sera-t-il lancé sur Kickstarter ?",
      paragraphs: [
        "Le lancement de LUKKEY sur Kickstarter est prévu pour 2026.",
        "Tous les détenteurs d'une réservation recevront un accès anticipé et une notification avant l'ouverture publique.",
      ],
    },
    faq8: {
      question: "Quels actifs LUKKEY prendra-t-il en charge ?",
      paragraphs: [
        "LUKKEY prend en charge plus de 30 réseaux blockchain ainsi que des milliers de cryptomonnaies et d'actifs NFT.",
        "Les utilisateurs peuvent gérer en toute sécurité à la fois des cryptomonnaies et des NFT sur un seul appareil.",
        "Davantage de réseaux et d'actifs continueront d'être ajoutés via les mises à jour du firmware et de l'application.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "et bien d'autres",
      ],
    },
  },
  es: {
    faq1: {
      question:
        "¿Qué hace que LUKKEY sea diferente de otras hardware wallets?",
      paragraphs: [
        "LUKKEY está diseñado para combinar una seguridad sólida con una gran facilidad de uso en el día a día.",
        "LUKKEY busca hacer que la autocustodia sea más segura y más sencilla para todos.",
      ],
      bullets: [
        "Chip secure element EAL6+ para una protección avanzada de las claves",
        "Autenticación por huella dactilar para un acceso rápido y seguro",
        "Tres wallets independientes en un solo dispositivo para separar activos y mejorar la privacidad",
        "Arquitectura de firma en frío para mantener las claves privadas totalmente fuera de línea",
      ],
    },
    faq2: {
      question: "¿LUKKEY es de código abierto?",
      paragraphs: [
        "Sí. LUKKEY es de código abierto, lo que permite que la comunidad revise el código y realice auditorías de seguridad independientes.",
        "Creemos que una hardware wallet debe ser transparente y verificable, y el código abierto es una parte central de esa confianza.",
      ],
    },
    faq3: {
      question: "¿Qué hace el secure element EAL6+?",
      paragraphs: [
        "El secure element EAL6+ es un chip especializado diseñado para proteger datos criptográficos sensibles.",
        "Almacena de forma segura tus claves privadas y realiza operaciones criptográficas dentro de un entorno resistente a manipulaciones, protegiendo tus activos frente a ataques físicos y digitales.",
        "Este nivel de certificación de seguridad se utiliza habitualmente en tarjetas bancarias, pasaportes y dispositivos de alta seguridad.",
      ],
    },
    faq4: {
      question: "¿Puedo crear tres wallets independientes en un solo dispositivo?",
      paragraphs: [
        "Sí.",
        "LUKKEY te permite crear tres wallets totalmente independientes en un solo dispositivo, cada uno con sus propias claves privadas y frase de recuperación.",
        "Cada wallet funciona de forma independiente y segura.",
      ],
      bullets: [
        "Separar fondos a largo plazo y fondos de uso diario",
        "Gestionar diferentes carteras",
        "Crear wallets ocultos o señuelo para una privacidad adicional",
      ],
    },
    faq5: {
      question: "¿Qué ocurre si pierdo el dispositivo?",
      paragraphs: [
        "Tus criptoactivos no se almacenan en el dispositivo, sino en la blockchain.",
        "Al configurar LUKKEY, generarás una frase de recuperación que se utiliza para restaurar tu wallet.",
        "LUKKEY también admite una tarjeta de respaldo NFC, que ofrece una forma cómoda de guardar de forma segura tu información de recuperación.",
        "Si tu dispositivo se pierde o se daña, puedes restaurar tu wallet mediante tu frase de recuperación o la tarjeta de respaldo NFC.",
        "Mientras tu copia de seguridad esté a salvo, tus fondos seguirán a salvo.",
      ],
    },
    faq6: {
      question: "¿Qué incluye la reserva de 1 USD?",
      paragraphs: [
        "La reserva de 1 USD asegura tu elegibilidad early bird y te coloca en la lista prioritaria antes del lanzamiento del crowdfunding.",
        "Antes de la apertura pública, recibirás la notificación anticipada y todos los beneficios de la reserva.",
      ],
      bullets: [
        "20 USD de descuento sobre el precio early bird",
        "Recibir primero el correo de lanzamiento y acceso anticipado a la página de crowdfunding",
        "Envío prioritario",
        "Acceso a la comunidad VIP",
        "Tarjeta de respaldo NFC de edición limitada y regalo IP exclusivo",
      ],
    },
    faq7: {
      question: "¿Cuándo se lanzará LUKKEY en Kickstarter?",
      paragraphs: [
        "Está previsto que LUKKEY se lance en Kickstarter en 2026.",
        "Todas las personas con reserva recibirán acceso anticipado y una notificación antes del lanzamiento público.",
      ],
    },
    faq8: {
      question: "¿Qué activos admitirá LUKKEY?",
      paragraphs: [
        "LUKKEY admite más de 30 redes blockchain y miles de criptomonedas y activos NFT.",
        "Los usuarios pueden gestionar de forma segura tanto criptomonedas como NFT en un solo dispositivo.",
        "Se seguirán añadiendo más redes y activos mediante actualizaciones del firmware y de la aplicación.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "y muchos más",
      ],
    },
  },
  ar: {
    faq1: {
      question: "ما الذي يميز LUKKEY عن غيره من المحافظ الصلبة؟",
      paragraphs: [
        "تم تصميم LUKKEY ليجمع بين الأمان القوي وسهولة الاستخدام اليومية.",
        "يهدف LUKKEY إلى جعل الحفظ الذاتي أكثر أماناً وأسهل للجميع.",
      ],
      bullets: [
        "شريحة عنصر آمن EAL6+ لحماية متقدمة للمفاتيح",
        "مصادقة ببصمة الإصبع للوصول السريع والآمن",
        "ثلاث محافظ مستقلة في جهاز واحد لعزل الأصول وتعزيز الخصوصية",
        "بنية توقيع بارد تُبقي المفاتيح الخاصة غير متصلة بالإنترنت بالكامل",
      ],
    },
    faq2: {
      question: "هل LUKKEY مفتوح المصدر؟",
      paragraphs: [
        "نعم. LUKKEY مفتوح المصدر، مما يتيح للمجتمع مراجعة الشيفرة وإجراء تدقيقات أمنية مستقلة.",
        "نحن نؤمن بأن المحفظة الصلبة يجب أن تكون شفافة وقابلة للتحقق، وأن الانفتاح في الشيفرة جزء أساسي من بناء هذه الثقة.",
      ],
    },
    faq3: {
      question: "ما وظيفة العنصر الآمن EAL6+؟",
      paragraphs: [
        "العنصر الآمن EAL6+ هو شريحة متخصصة صُممت لحماية البيانات التشفيرية الحساسة.",
        "يقوم بتخزين مفاتيحك الخاصة بشكل آمن وإجراء العمليات التشفيرية داخل بيئة مقاومة للعبث، مما يحمي أصولك من الهجمات المادية والرقمية.",
        "يُستخدم هذا المستوى من الاعتماد الأمني عادةً في البطاقات المصرفية وجوازات السفر والأجهزة عالية الأمان.",
      ],
    },
    faq4: {
      question: "هل يمكنني إنشاء ثلاث محافظ مستقلة على جهاز واحد؟",
      paragraphs: [
        "نعم.",
        "يتيح لك LUKKEY إنشاء ثلاث محافظ مستقلة تماماً على جهاز واحد، ولكل منها مفاتيحها الخاصة وعبارة الاسترداد الخاصة بها.",
        "كل محفظة تعمل بشكل مستقل وآمن.",
      ],
      bullets: [
        "فصل المقتنيات طويلة الأجل عن الأموال اليومية",
        "إدارة محافظ استثمارية مختلفة",
        "إنشاء محافظ مخفية أو تمويهية لتعزيز الخصوصية",
      ],
    },
    faq5: {
      question: "ماذا يحدث إذا فقدت الجهاز؟",
      paragraphs: [
        "أصولك المشفرة ليست مخزنة على الجهاز، بل على البلوك تشين.",
        "عند إعداد LUKKEY، ستنشئ عبارة استرداد تُستخدم لاستعادة محفظتك.",
        "يدعم LUKKEY أيضاً بطاقة نسخ احتياطي NFC، ما يوفر طريقة مريحة لتخزين معلومات الاسترداد بشكل آمن.",
        "إذا فُقد جهازك أو تعرض للتلف، يمكنك استعادة محفظتك باستخدام عبارة الاسترداد أو بطاقة النسخ الاحتياطي NFC.",
        "طالما أن النسخة الاحتياطية آمنة، فإن أموالك ستبقى آمنة.",
      ],
    },
    faq6: {
      question: "ماذا يشمل الحجز مقابل 1 دولار؟",
      paragraphs: [
        "يؤمّن الحجز مقابل 1 دولار أهليتك للسعر المبكر ويضعك على قائمة الأولوية قبل إطلاق حملة التمويل الجماعي.",
        "قبل الإطلاق العام، ستتلقى إشعاراً مبكراً وكامل مزايا الحجز.",
      ],
      bullets: [
        "خصم 20 دولاراً من سعر early bird",
        "استلام رسالة الإطلاق أولاً والحصول على وصول مبكر إلى صفحة التمويل الجماعي",
        "شحن ذو أولوية",
        "دخول إلى مجتمع VIP",
        "بطاقة نسخ احتياطي NFC بإصدار محدود وهدية IP حصرية",
      ],
    },
    faq7: {
      question: "متى سيتم إطلاق LUKKEY على Kickstarter؟",
      paragraphs: [
        "من المخطط إطلاق LUKKEY على Kickstarter في عام 2026.",
        "سيحصل جميع أصحاب الحجز على وصول مبكر وإشعار قبل الإطلاق العام.",
      ],
    },
    faq8: {
      question: "ما الأصول التي سيدعمها LUKKEY؟",
      paragraphs: [
        "يدعم LUKKEY أكثر من 30 شبكة بلوك تشين وآلاف العملات المشفرة وأصول NFT.",
        "يمكن للمستخدمين إدارة العملات المشفرة وNFT بشكل آمن على جهاز واحد.",
        "ستتم إضافة المزيد من الشبكات والأصول باستمرار عبر تحديثات البرامج الثابتة والتطبيق.",
      ],
      bullets: [
        "بيتكوين (BTC)",
        "إيثريوم (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "وغير ذلك الكثير",
      ],
    },
  },
  ja: {
    faq1: {
      question: "LUKKEY は他のハードウェアウォレットと何が違いますか？",
      paragraphs: [
        "LUKKEY は、強固なセキュリティと日常的な使いやすさを両立するように設計されています。",
        "LUKKEY は、セルフカストディをより安全に、より簡単にすることを目指しています。",
      ],
      bullets: [
        "高度な鍵保護を実現する EAL6+ セキュアエレメントチップ",
        "すばやく安全にアクセスできる指紋認証",
        "資産分離とプライバシー管理のために 1 台で 3 つの独立ウォレットを利用可能",
        "秘密鍵を完全にオフラインに保つコールド署名アーキテクチャ",
      ],
    },
    faq2: {
      question: "LUKKEY はオープンソースですか？",
      paragraphs: [
        "はい。LUKKEY はオープンソースであり、コミュニティがコードを確認し、独立したセキュリティ監査を行えます。",
        "私たちは、ハードウェアウォレットは透明で検証可能であるべきだと考えており、オープンソースはその信頼を支える中核です。",
      ],
    },
    faq3: {
      question: "EAL6+ セキュアエレメントは何をしますか？",
      paragraphs: [
        "EAL6+ セキュアエレメントは、機密性の高い暗号データを保護するために設計された専用チップです。",
        "秘密鍵を安全に保管し、耐改ざん環境の内部で暗号処理を実行することで、物理的およびデジタルな攻撃から資産を守ります。",
        "このレベルのセキュリティ認証は、銀行カード、パスポート、高セキュリティ機器などで広く使われています。",
      ],
    },
    faq4: {
      question: "1 台のデバイスで 3 つの独立ウォレットを作成できますか？",
      paragraphs: [
        "はい。",
        "LUKKEY では、1 台のデバイス上に、秘密鍵とリカバリーフレーズがそれぞれ異なる 3 つの完全に独立したウォレットを作成できます。",
        "各ウォレットは独立して安全に動作します。",
      ],
      bullets: [
        "長期保有用資産と日常利用資金を分ける",
        "異なるポートフォリオを管理する",
        "追加のプライバシーのために隠しウォレットやデコイウォレットを作成する",
      ],
    },
    faq5: {
      question: "デバイスを紛失したらどうなりますか？",
      paragraphs: [
        "暗号資産はデバイスではなく、ブロックチェーン上に保管されています。",
        "LUKKEY の初期設定時に、ウォレット復元に使用するリカバリーフレーズを生成します。",
        "LUKKEY は NFC バックアップカードにも対応しており、復元情報を安全に保管するための便利な方法を提供します。",
        "デバイスを紛失または破損した場合でも、リカバリーフレーズまたは NFC バックアップカードを使ってウォレットを復元できます。",
        "バックアップが安全である限り、資金も安全です。",
      ],
    },
    faq6: {
      question: "$1 予約には何が含まれますか？",
      paragraphs: [
        "$1 の予約で、アーリーバード対象を確保し、クラウドファンディング開始前の優先リストに入れます。",
        "一般公開前に通知を受け取り、予約者向けの特典をすべて受け取れます。",
      ],
      bullets: [
        "アーリーバード価格から 20 ドル割引",
        "公開前にローンチメールを最初に受け取り、クラウドファンディングページへ先行アクセス",
        "優先発送",
        "VIP コミュニティ参加権",
        "限定版 NFC バックアップカードと限定 IP ギフト",
      ],
    },
    faq7: {
      question: "LUKKEY はいつ Kickstarter で開始されますか？",
      paragraphs: [
        "LUKKEY は 2026 年に Kickstarter での開始を予定しています。",
        "予約者全員が、一般公開前に先行アクセス権と通知を受け取ります。",
      ],
    },
    faq8: {
      question: "LUKKEY はどの資産に対応しますか？",
      paragraphs: [
        "LUKKEY は 30 以上のブロックチェーンネットワークと、数千の暗号資産および NFT 資産に対応します。",
        "ユーザーは 1 台のデバイスで暗号資産と NFT の両方を安全に管理できます。",
        "今後もファームウェアとアプリの更新を通じて、対応ネットワークと資産を追加していきます。",
      ],
      bullets: [
        "ビットコイン (BTC)",
        "イーサリアム (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "など多数",
      ],
    },
  },
  ru: {
    faq1: {
      question:
        "Чем LUKKEY отличается от других аппаратных кошельков?",
      paragraphs: [
        "LUKKEY создан так, чтобы сочетать высокий уровень безопасности с удобством в повседневном использовании.",
        "LUKKEY стремится сделать самостоятельное хранение активов безопаснее и проще для всех.",
      ],
      bullets: [
        "Чип secure element уровня EAL6+ для продвинутой защиты ключей",
        "Аутентификация по отпечатку пальца для быстрого и безопасного доступа",
        "Три независимых кошелька на одном устройстве для разделения активов и повышения приватности",
        "Архитектура cold signing, чтобы приватные ключи всегда оставались полностью офлайн",
      ],
    },
    faq2: {
      question: "LUKKEY с открытым исходным кодом?",
      paragraphs: [
        "Да. LUKKEY имеет открытый исходный код, поэтому сообщество может проверять код и проводить независимые аудиты безопасности.",
        "Мы считаем, что аппаратный кошелек должен быть прозрачным и проверяемым, а открытый исходный код является ключевой частью такого доверия.",
      ],
    },
    faq3: {
      question: "Что делает secure element EAL6+?",
      paragraphs: [
        "Secure element EAL6+ — это специализированный чип, предназначенный для защиты чувствительных криптографических данных.",
        "Он безопасно хранит ваши приватные ключи и выполняет криптографические операции внутри защищённой от вмешательства среды, защищая активы от физических и цифровых атак.",
        "Такой уровень сертификации безопасности обычно используется в банковских картах, паспортах и устройствах повышенной защиты.",
      ],
    },
    faq4: {
      question: "Могу ли я создать три независимых кошелька на одном устройстве?",
      paragraphs: [
        "Да.",
        "LUKKEY позволяет создать на одном устройстве три полностью независимых кошелька, каждый со своими приватными ключами и фразой восстановления.",
        "Каждый кошелёк работает независимо и безопасно.",
      ],
      bullets: [
        "Разделять долгосрочные накопления и повседневные средства",
        "Управлять разными портфелями",
        "Создавать скрытые или отвлекающие кошельки для дополнительной приватности",
      ],
    },
    faq5: {
      question: "Что произойдёт, если я потеряю устройство?",
      paragraphs: [
        "Ваши криптоактивы хранятся не на устройстве, а в блокчейне.",
        "При настройке LUKKEY вы создаёте фразу восстановления, которая используется для восстановления кошелька.",
        "LUKKEY также поддерживает NFC-карту резервного копирования, обеспечивая удобный способ безопасно хранить данные для восстановления.",
        "Если устройство потеряно или повреждено, вы сможете восстановить кошелёк с помощью фразы восстановления или NFC-карты резервного копирования.",
        "Пока ваша резервная копия в безопасности, ваши средства остаются в безопасности.",
      ],
    },
    faq6: {
      question: "Что включает бронирование за 1 доллар?",
      paragraphs: [
        "Бронирование за 1 доллар закрепляет за вами право на early-bird условия и место в приоритетном списке до запуска краудфандинга.",
        "До публичного запуска вы получите раннее уведомление и полный набор бонусов бронирования.",
      ],
      bullets: [
        "Скидка 20 долларов от цены early bird",
        "Раннее письмо о запуске и ранний доступ к странице краудфандинга",
        "Приоритетная доставка",
        "Доступ в VIP-сообщество",
        "Лимитированная NFC-карта для резервного копирования и эксклюзивный IP-подарок",
      ],
    },
    faq7: {
      question: "Когда LUKKEY выйдет на Kickstarter?",
      paragraphs: [
        "Запуск LUKKEY на Kickstarter запланирован на 2026 год.",
        "Все держатели бронирования получат ранний доступ и уведомление до публичного запуска.",
      ],
    },
    faq8: {
      question: "Какие активы будет поддерживать LUKKEY?",
      paragraphs: [
        "LUKKEY поддерживает более 30 блокчейн-сетей и тысячи криптовалют и NFT-активов.",
        "Пользователи смогут безопасно управлять как криптовалютами, так и NFT на одном устройстве.",
        "Список сетей и активов будет расширяться за счёт обновлений прошивки и приложения.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "и многое другое",
      ],
    },
  },
  ko: {
    faq1: {
      question: "LUKKEY는 다른 하드웨어 지갑과 무엇이 다른가요?",
      paragraphs: [
        "LUKKEY는 강력한 보안성과 일상적인 사용 편의성을 함께 갖추도록 설계되었습니다.",
        "LUKKEY는 셀프 커스터디를 모두에게 더 안전하고 더 쉽게 만드는 것을 목표로 합니다.",
      ],
      bullets: [
        "고급 키 보호를 위한 EAL6+ 보안 요소 칩",
        "빠르고 안전한 접근을 위한 지문 인증",
        "자산 분리와 프라이버시 관리를 위한 하나의 기기 안의 3개 독립 지갑",
        "개인 키를 완전히 오프라인 상태로 유지하는 콜드 서명 구조",
      ],
    },
    faq2: {
      question: "LUKKEY는 오픈 소스인가요?",
      paragraphs: [
        "네. LUKKEY는 오픈 소스이며, 커뮤니티가 코드를 검토하고 독립적인 보안 감사를 수행할 수 있습니다.",
        "우리는 하드웨어 지갑이 투명하고 검증 가능해야 한다고 생각하며, 오픈 소스는 그 신뢰를 만드는 핵심 요소입니다.",
      ],
    },
    faq3: {
      question: "EAL6+ 보안 요소는 어떤 역할을 하나요?",
      paragraphs: [
        "EAL6+ 보안 요소는 민감한 암호화 데이터를 보호하도록 설계된 특수 칩입니다.",
        "개인 키를 안전하게 저장하고, 변조 방지 환경 내부에서 암호화 연산을 수행하여 물리적 및 디지털 공격으로부터 자산을 보호합니다.",
        "이 수준의 보안 인증은 일반적으로 은행 카드, 여권, 고보안 장치에 사용됩니다.",
      ],
    },
    faq4: {
      question: "하나의 기기에서 3개의 독립 지갑을 만들 수 있나요?",
      paragraphs: [
        "네.",
        "LUKKEY는 하나의 기기에서 각기 다른 개인 키와 복구 문구를 가진 3개의 완전히 독립적인 지갑을 만들 수 있도록 지원합니다.",
        "각 지갑은 독립적이고 안전하게 동작합니다.",
      ],
      bullets: [
        "장기 보유 자산과 일상 자금을 분리하기",
        "서로 다른 포트폴리오 관리하기",
        "추가적인 프라이버시를 위해 숨김 지갑 또는 미끼 지갑 만들기",
      ],
    },
    faq5: {
      question: "기기를 분실하면 어떻게 되나요?",
      paragraphs: [
        "암호화 자산은 기기에 저장되는 것이 아니라 블록체인에 저장됩니다.",
        "LUKKEY를 설정할 때 지갑 복구에 사용할 복구 문구를 생성하게 됩니다.",
        "LUKKEY는 NFC 백업 카드도 지원하여 복구 정보를 안전하게 보관할 수 있는 편리한 방법을 제공합니다.",
        "기기를 분실하거나 손상된 경우 복구 문구 또는 NFC 백업 카드를 사용해 지갑을 복원할 수 있습니다.",
        "백업이 안전하게 보관되어 있다면 자산도 안전합니다.",
      ],
    },
    faq6: {
      question: "$1 예약에는 무엇이 포함되나요?",
      paragraphs: [
        "$1 예약은 얼리버드 자격을 확보하고 크라우드펀딩 시작 전에 우선 명단에 오를 수 있게 해줍니다.",
        "공개 런칭 전에 먼저 알림을 받고, 전체 예약 혜택을 받을 수 있습니다.",
      ],
      bullets: [
        "얼리버드 가격에서 $20 할인",
        "런칭 이메일을 가장 먼저 받고 크라우드펀딩 페이지에 먼저 접근",
        "우선 배송",
        "VIP 커뮤니티 이용 권한",
        "한정판 NFC 백업 카드와 전용 IP 기프트",
      ],
    },
    faq7: {
      question: "LUKKEY는 언제 Kickstarter에서 출시되나요?",
      paragraphs: [
        "LUKKEY는 2026년에 Kickstarter에서 출시될 예정입니다.",
        "예약한 모든 사용자는 공개 출시 전에 먼저 알림과 조기 접근 권한을 받게 됩니다.",
      ],
    },
    faq8: {
      question: "LUKKEY는 어떤 자산을 지원하나요?",
      paragraphs: [
        "LUKKEY는 30개 이상의 블록체인 네트워크와 수천 개의 암호화폐 및 NFT 자산을 지원합니다.",
        "사용자는 하나의 기기에서 암호화폐와 NFT를 모두 안전하게 관리할 수 있습니다.",
        "추가 네트워크와 자산은 펌웨어와 앱 업데이트를 통해 계속 확대될 예정입니다.",
      ],
      bullets: [
        "비트코인 (BTC)",
        "이더리움 (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "그리고 더 많은 자산",
      ],
    },
  },
  pt: {
    faq1: {
      question: "O que diferencia a LUKKEY de outras hardware wallets?",
      paragraphs: [
        "A LUKKEY foi concebida para combinar segurança robusta com facilidade de utilização no dia a dia.",
        "A LUKKEY pretende tornar a autocustódia mais segura e mais simples para todos.",
      ],
      bullets: [
        "Chip secure element EAL6+ para proteção avançada das chaves",
        "Autenticação por impressão digital para acesso rápido e seguro",
        "Três wallets independentes num único dispositivo para separação de ativos e privacidade",
        "Arquitetura de cold signing para manter as chaves privadas totalmente offline",
      ],
    },
    faq2: {
      question: "A LUKKEY é open source?",
      paragraphs: [
        "Sim. A LUKKEY é open source, permitindo que a comunidade revise o código e realize auditorias de segurança independentes.",
        "Acreditamos que uma hardware wallet deve ser transparente e verificável, e o open source é uma parte central dessa confiança.",
      ],
    },
    faq3: {
      question: "O que faz o secure element EAL6+?",
      paragraphs: [
        "O secure element EAL6+ é um chip especializado concebido para proteger dados criptográficos sensíveis.",
        "Armazena as suas chaves privadas com segurança e executa operações criptográficas num ambiente resistente a adulterações, protegendo os seus ativos contra ataques físicos e digitais.",
        "Este nível de certificação de segurança é comum em cartões bancários, passaportes e dispositivos de alta segurança.",
      ],
    },
    faq4: {
      question: "Posso criar três wallets independentes num único dispositivo?",
      paragraphs: [
        "Sim.",
        "A LUKKEY permite criar três wallets totalmente independentes num único dispositivo, cada uma com as suas próprias chaves privadas e frase de recuperação.",
        "Cada wallet funciona de forma independente e segura.",
      ],
      bullets: [
        "Separar poupanças de longo prazo dos fundos do dia a dia",
        "Gerir diferentes carteiras",
        "Criar wallets ocultas ou de engodo para reforçar a privacidade",
      ],
    },
    faq5: {
      question: "O que acontece se eu perder o dispositivo?",
      paragraphs: [
        "Os seus criptoativos não ficam armazenados no dispositivo, mas sim na blockchain.",
        "Ao configurar a LUKKEY, irá gerar uma frase de recuperação utilizada para restaurar a sua wallet.",
        "A LUKKEY também suporta um cartão de backup NFC, oferecendo uma forma prática de guardar as suas informações de recuperação com segurança.",
        "Se o seu dispositivo for perdido ou danificado, poderá restaurar a sua wallet utilizando a frase de recuperação ou o cartão de backup NFC.",
        "Desde que o seu backup esteja seguro, os seus fundos continuam seguros.",
      ],
    },
    faq6: {
      question: "O que inclui a reserva de 1 dólar?",
      paragraphs: [
        "A reserva de 1 dólar garante a sua elegibilidade early bird e coloca-o na lista prioritária antes do lançamento da campanha de crowdfunding.",
        "Antes do lançamento público, receberá uma notificação antecipada e todas as vantagens da reserva.",
      ],
      bullets: [
        "20 dólares de desconto sobre o preço early bird",
        "Receber primeiro o e-mail de lançamento e acesso antecipado à página de crowdfunding",
        "Envio prioritário",
        "Acesso à comunidade VIP",
        "Cartão de backup NFC em edição limitada e oferta IP exclusiva",
      ],
    },
    faq7: {
      question: "Quando será lançado o LUKKEY no Kickstarter?",
      paragraphs: [
        "Está previsto que a LUKKEY seja lançada no Kickstarter em 2026.",
        "Todos os titulares de reserva receberão acesso antecipado e notificação antes do lançamento público.",
      ],
    },
    faq8: {
      question: "Que ativos irá a LUKKEY suportar?",
      paragraphs: [
        "A LUKKEY suporta mais de 30 redes blockchain e milhares de criptomoedas e ativos NFT.",
        "Os utilizadores podem gerir com segurança tanto criptomoedas como NFTs num único dispositivo.",
        "Mais redes e ativos continuarão a ser adicionados através de atualizações de firmware e da aplicação.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "e muitos mais",
      ],
    },
  },
  "pt-BR": {
    faq1: {
      question: "O que torna a LUKKEY diferente de outras hardware wallets?",
      paragraphs: [
        "A LUKKEY foi projetada para combinar segurança forte com facilidade de uso no dia a dia.",
        "A LUKKEY quer tornar a autocustódia mais segura e mais simples para todo mundo.",
      ],
      bullets: [
        "Chip secure element EAL6+ para proteção avançada das chaves",
        "Autenticação por impressão digital para acesso rápido e seguro",
        "Três wallets independentes em um único dispositivo para separação de ativos e privacidade",
        "Arquitetura de cold signing para manter as chaves privadas totalmente offline",
      ],
    },
    faq2: {
      question: "A LUKKEY é open source?",
      paragraphs: [
        "Sim. A LUKKEY é open source, permitindo que a comunidade revise o código e realize auditorias de segurança independentes.",
        "Acreditamos que uma hardware wallet deve ser transparente e verificável, e o open source é uma parte central dessa confiança.",
      ],
    },
    faq3: {
      question: "O que faz o secure element EAL6+?",
      paragraphs: [
        "O secure element EAL6+ é um chip especializado projetado para proteger dados criptográficos sensíveis.",
        "Ele armazena suas chaves privadas com segurança e executa operações criptográficas dentro de um ambiente resistente a violações, protegendo seus ativos contra ataques físicos e digitais.",
        "Esse nível de certificação de segurança é comum em cartões bancários, passaportes e dispositivos de alta segurança.",
      ],
    },
    faq4: {
      question: "Posso criar três wallets independentes em um único dispositivo?",
      paragraphs: [
        "Sim.",
        "A LUKKEY permite criar três wallets totalmente independentes em um único dispositivo, cada uma com suas próprias chaves privadas e frase de recuperação.",
        "Cada wallet funciona de forma independente e segura.",
      ],
      bullets: [
        "Separar reservas de longo prazo dos fundos do dia a dia",
        "Gerenciar diferentes carteiras",
        "Criar wallets ocultas ou de disfarce para mais privacidade",
      ],
    },
    faq5: {
      question: "O que acontece se eu perder o dispositivo?",
      paragraphs: [
        "Seus criptoativos não ficam armazenados no dispositivo, mas na blockchain.",
        "Ao configurar a LUKKEY, você gera uma frase de recuperação usada para restaurar sua wallet.",
        "A LUKKEY também oferece suporte a um cartão de backup NFC, proporcionando uma forma prática de armazenar suas informações de recuperação com segurança.",
        "Se o seu dispositivo for perdido ou danificado, você poderá restaurar sua wallet usando a frase de recuperação ou o cartão de backup NFC.",
        "Desde que seu backup esteja seguro, seus fundos continuam seguros.",
      ],
    },
    faq6: {
      question: "O que inclui a reserva de US$1?",
      paragraphs: [
        "A reserva de US$1 garante sua elegibilidade early bird e coloca você na lista prioritária antes do lançamento do crowdfunding.",
        "Antes do lançamento público, você receberá a notificação antecipada e todos os benefícios da reserva.",
      ],
      bullets: [
        "US$20 de desconto no preço early bird",
        "Receber primeiro o e-mail de lançamento e acesso antecipado à página de crowdfunding",
        "Envio prioritário",
        "Acesso à comunidade VIP",
        "Cartão de backup NFC em edição limitada e presente IP exclusivo",
      ],
    },
    faq7: {
      question: "Quando a LUKKEY será lançada no Kickstarter?",
      paragraphs: [
        "O lançamento da LUKKEY no Kickstarter está previsto para 2026.",
        "Todas as pessoas com reserva receberão acesso antecipado e notificação antes do lançamento público.",
      ],
    },
    faq8: {
      question: "Quais ativos a LUKKEY vai suportar?",
      paragraphs: [
        "A LUKKEY suporta mais de 30 redes blockchain e milhares de criptomoedas e ativos NFT.",
        "Os usuários podem gerenciar com segurança tanto criptomoedas quanto NFTs em um único dispositivo.",
        "Mais redes e ativos continuarão a ser adicionados por meio de atualizações de firmware e do app.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "e muitos outros",
      ],
    },
  },
  it: {
    faq1: {
      question: "Cosa rende LUKKEY diverso dagli altri hardware wallet?",
      paragraphs: [
        "LUKKEY è progettato per unire una sicurezza elevata a un'esperienza d'uso pratica ogni giorno.",
        "LUKKEY vuole rendere la self-custody più sicura e più semplice per tutti.",
      ],
      bullets: [
        "Chip secure element EAL6+ per una protezione avanzata delle chiavi",
        "Autenticazione tramite impronta digitale per un accesso rapido e sicuro",
        "Tre wallet indipendenti su un solo dispositivo per separazione degli asset e privacy",
        "Architettura di cold signing per mantenere le chiavi private completamente offline",
      ],
    },
    faq2: {
      question: "LUKKEY è open source?",
      paragraphs: [
        "Sì. LUKKEY è open source, consentendo alla comunità di esaminare il codice ed eseguire audit di sicurezza indipendenti.",
        "Crediamo che un hardware wallet debba essere trasparente e verificabile, e l'open source è una parte fondamentale di questa fiducia.",
      ],
    },
    faq3: {
      question: "A cosa serve il secure element EAL6+?",
      paragraphs: [
        "Il secure element EAL6+ è un chip specializzato progettato per proteggere dati crittografici sensibili.",
        "Conserva in modo sicuro le tue chiavi private ed esegue operazioni crittografiche in un ambiente resistente alle manomissioni, proteggendo i tuoi asset da attacchi fisici e digitali.",
        "Questo livello di certificazione di sicurezza è comunemente utilizzato in carte bancarie, passaporti e dispositivi ad alta sicurezza.",
      ],
    },
    faq4: {
      question:
        "Posso creare tre wallet indipendenti su un solo dispositivo?",
      paragraphs: [
        "Sì.",
        "LUKKEY consente di creare tre wallet completamente indipendenti su un unico dispositivo, ognuno con le proprie chiavi private e la propria frase di recupero.",
        "Ogni wallet opera in modo indipendente e sicuro.",
      ],
      bullets: [
        "Separare risparmi di lungo periodo e fondi quotidiani",
        "Gestire portafogli differenti",
        "Creare wallet nascosti o esca per una privacy aggiuntiva",
      ],
    },
    faq5: {
      question: "Cosa succede se perdo il dispositivo?",
      paragraphs: [
        "I tuoi criptoasset non sono memorizzati sul dispositivo, ma sulla blockchain.",
        "Durante la configurazione di LUKKEY genererai una frase di recupero utilizzata per ripristinare il wallet.",
        "LUKKEY supporta anche una scheda di backup NFC, offrendo un modo pratico per conservare in sicurezza le informazioni di recupero.",
        "Se il dispositivo viene perso o danneggiato, puoi ripristinare il wallet usando la frase di recupero o la scheda di backup NFC.",
        "Finché il backup è al sicuro, anche i tuoi fondi restano al sicuro.",
      ],
    },
    faq6: {
      question: "Cosa include la prenotazione da 1 $?",
      paragraphs: [
        "La prenotazione da 1 $ garantisce l'idoneità early bird e ti inserisce nella lista prioritaria prima del lancio del crowdfunding.",
        "Prima del lancio pubblico riceverai una notifica anticipata e tutti i vantaggi della prenotazione.",
      ],
      bullets: [
        "20 $ di sconto sul prezzo early bird",
        "Ricevere per primi l'e-mail di lancio e l'accesso anticipato alla pagina di crowdfunding",
        "Spedizione prioritaria",
        "Accesso alla community VIP",
        "Scheda di backup NFC in edizione limitata e regalo IP esclusivo",
      ],
    },
    faq7: {
      question: "Quando verrà lanciato LUKKEY su Kickstarter?",
      paragraphs: [
        "Il lancio di LUKKEY su Kickstarter è previsto per il 2026.",
        "Tutti i titolari di prenotazione riceveranno accesso anticipato e notifica prima del lancio pubblico.",
      ],
    },
    faq8: {
      question: "Quali asset supporterà LUKKEY?",
      paragraphs: [
        "LUKKEY supporta oltre 30 reti blockchain e migliaia di criptovalute e asset NFT.",
        "Gli utenti possono gestire in sicurezza sia criptovalute sia NFT su un unico dispositivo.",
        "Altre reti e altri asset continueranno ad aggiungersi tramite aggiornamenti del firmware e dell'app.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "e molti altri",
      ],
    },
  },
  de: {
    faq1: {
      question: "Was unterscheidet LUKKEY von anderen Hardware-Wallets?",
      paragraphs: [
        "LUKKEY wurde entwickelt, um starke Sicherheit mit alltagstauglicher Benutzerfreundlichkeit zu verbinden.",
        "LUKKEY möchte Self-Custody für alle sicherer und einfacher machen.",
      ],
      bullets: [
        "EAL6+ Secure-Element-Chip für erweiterten Schlüsselschutz",
        "Fingerabdruck-Authentifizierung für schnellen und sicheren Zugriff",
        "Drei unabhängige Wallets auf einem Gerät für Vermögenstrennung und Privatsphäre",
        "Cold-Signing-Architektur, damit private Schlüssel vollständig offline bleiben",
      ],
    },
    faq2: {
      question: "Ist LUKKEY Open Source?",
      paragraphs: [
        "Ja. LUKKEY ist Open Source, sodass die Community den Code prüfen und unabhängige Sicherheitsaudits durchführen kann.",
        "Wir sind überzeugt, dass eine Hardware-Wallet transparent und überprüfbar sein sollte, und Open Source ist ein zentraler Bestandteil dieses Vertrauens.",
      ],
    },
    faq3: {
      question: "Was macht das EAL6+ Secure Element?",
      paragraphs: [
        "Das EAL6+ Secure Element ist ein spezialisierter Chip zum Schutz sensibler kryptografischer Daten.",
        "Es speichert Ihre privaten Schlüssel sicher und führt kryptografische Operationen in einer manipulationsgeschützten Umgebung aus, um Ihre Vermögenswerte vor physischen und digitalen Angriffen zu schützen.",
        "Dieses Sicherheitsniveau wird häufig bei Bankkarten, Pässen und Hochsicherheitsgeräten eingesetzt.",
      ],
    },
    faq4: {
      question:
        "Kann ich auf einem Gerät drei unabhängige Wallets erstellen?",
      paragraphs: [
        "Ja.",
        "LUKKEY ermöglicht es Ihnen, auf einem einzigen Gerät drei vollständig unabhängige Wallets zu erstellen, jeweils mit eigenen privaten Schlüsseln und eigener Recovery-Phrase.",
        "Jedes Wallet arbeitet unabhängig und sicher.",
      ],
      bullets: [
        "Langfristige Bestände und tägliche Mittel getrennt halten",
        "Unterschiedliche Portfolios verwalten",
        "Versteckte oder Täuschungs-Wallets für zusätzliche Privatsphäre erstellen",
      ],
    },
    faq5: {
      question: "Was passiert, wenn ich das Gerät verliere?",
      paragraphs: [
        "Ihre Krypto-Assets werden nicht auf dem Gerät gespeichert, sondern auf der Blockchain.",
        "Beim Einrichten von LUKKEY erzeugen Sie eine Recovery-Phrase, mit der sich Ihr Wallet wiederherstellen lässt.",
        "LUKKEY unterstützt außerdem eine NFC-Backup-Karte und bietet damit eine praktische Möglichkeit, Ihre Wiederherstellungsinformationen sicher zu speichern.",
        "Wenn Ihr Gerät verloren geht oder beschädigt wird, können Sie Ihr Wallet mit Ihrer Recovery-Phrase oder der NFC-Backup-Karte wiederherstellen.",
        "Solange Ihr Backup sicher ist, bleiben auch Ihre Funds sicher.",
      ],
    },
    faq6: {
      question: "Was beinhaltet die 1-Dollar-Reservierung?",
      paragraphs: [
        "Die 1-Dollar-Reservierung sichert Ihnen Ihre Early-Bird-Berechtigung und einen Platz auf der Prioritätenliste vor dem Crowdfunding-Start.",
        "Vor dem öffentlichen Launch erhalten Sie eine frühe Benachrichtigung und alle Reservierungsvorteile.",
      ],
      bullets: [
        "20 Dollar Rabatt auf den Early-Bird-Preis",
        "Launch-E-Mail zuerst erhalten und früher Zugang zur Crowdfunding-Seite",
        "Priorisierter Versand",
        "Zugang zur VIP-Community",
        "Limitierte NFC-Backup-Karte und exklusives IP-Geschenk",
      ],
    },
    faq7: {
      question: "Wann startet LUKKEY auf Kickstarter?",
      paragraphs: [
        "Der Start von LUKKEY auf Kickstarter ist für 2026 geplant.",
        "Alle Reservierungsinhaber erhalten vor dem öffentlichen Start einen frühen Zugang und eine Benachrichtigung.",
      ],
    },
    faq8: {
      question: "Welche Assets wird LUKKEY unterstützen?",
      paragraphs: [
        "LUKKEY unterstützt mehr als 30 Blockchain-Netzwerke sowie Tausende Kryptowährungen und NFT-Assets.",
        "Nutzer können sowohl Kryptowährungen als auch NFTs sicher auf einem einzigen Gerät verwalten.",
        "Weitere Netzwerke und Assets werden fortlaufend über Firmware- und App-Updates hinzugefügt.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "und viele mehr",
      ],
    },
  },
  hi: {
    faq1: {
      question: "LUKKEY अन्य हार्डवेयर वॉलेट्स से किस तरह अलग है?",
      paragraphs: [
        "LUKKEY को मजबूत सुरक्षा और रोजमर्रा की उपयोगिता को साथ लाने के लिए डिज़ाइन किया गया है।",
        "LUKKEY का उद्देश्य self-custody को सभी के लिए अधिक सुरक्षित और आसान बनाना है।",
      ],
      bullets: [
        "उन्नत key protection के लिए EAL6+ secure element chip",
        "तेज़ और सुरक्षित access के लिए fingerprint authentication",
        "Asset separation और privacy के लिए एक device में तीन independent wallets",
        "Private keys को पूरी तरह offline रखने के लिए cold-signing architecture",
      ],
    },
    faq2: {
      question: "क्या LUKKEY ओपन सोर्स है?",
      paragraphs: [
        "हाँ। LUKKEY ओपन सोर्स है, जिससे समुदाय कोड की समीक्षा कर सकता है और स्वतंत्र सुरक्षा ऑडिट कर सकता है।",
        "हम मानते हैं कि एक हार्डवेयर वॉलेट पारदर्शी और सत्यापित करने योग्य होना चाहिए, और ओपन सोर्स उस भरोसे का एक मुख्य हिस्सा है।",
      ],
    },
    faq3: {
      question: "EAL6+ secure element क्या करता है?",
      paragraphs: [
        "EAL6+ secure element एक विशेष chip है जिसे संवेदनशील cryptographic data की सुरक्षा के लिए बनाया गया है।",
        "यह आपकी private keys को सुरक्षित रखता है और tamper-resistant environment के भीतर cryptographic operations करता है, जिससे आपके assets physical और digital हमलों से सुरक्षित रहते हैं।",
        "इस स्तर की security certification आमतौर पर bank cards, passports और high-security devices में उपयोग की जाती है।",
      ],
    },
    faq4: {
      question: "क्या मैं एक device पर तीन independent wallets बना सकता हूँ?",
      paragraphs: [
        "हाँ।",
        "LUKKEY आपको एक ही device पर तीन पूरी तरह independent wallets बनाने देता है, जिनमें से प्रत्येक की अपनी private keys और recovery phrase होती है।",
        "हर wallet स्वतंत्र और सुरक्षित रूप से काम करता है।",
      ],
      bullets: [
        "Long-term holdings और daily funds को अलग रखना",
        "अलग-अलग portfolios मैनेज करना",
        "अतिरिक्त privacy के लिए hidden या decoy wallets बनाना",
      ],
    },
    faq5: {
      question: "अगर मैं device खो दूँ तो क्या होगा?",
      paragraphs: [
        "आपके crypto assets device पर नहीं, बल्कि blockchain पर stored होते हैं।",
        "LUKKEY सेट करते समय आप एक recovery phrase generate करेंगे जिसका उपयोग आपके wallet को restore करने के लिए होता है।",
        "LUKKEY NFC backup card को भी support करता है, जिससे आपकी recovery information को सुरक्षित रूप से store करना अधिक सुविधाजनक हो जाता है।",
        "अगर आपका device खो जाता है या damage हो जाता है, तो आप recovery phrase या NFC backup card से wallet restore कर सकते हैं।",
        "जब तक आपका backup सुरक्षित है, आपके funds भी सुरक्षित हैं।",
      ],
    },
    faq6: {
      question: "$1 reservation में क्या शामिल है?",
      paragraphs: [
        "$1 reservation आपकी early-bird eligibility सुरक्षित करता है और crowdfunding launch से पहले आपको priority list में रखता है।",
        "Public launch से पहले आपको early notification और reservation के सभी benefits मिलेंगे।",
      ],
      bullets: [
        "Early-bird price पर $20 की छूट",
        "Launch email सबसे पहले पाना और crowdfunding page तक early access",
        "Priority shipping",
        "VIP community access",
        "Limited-edition NFC backup card और exclusive IP gift",
      ],
    },
    faq7: {
      question: "LUKKEY Kickstarter पर कब लॉन्च होगा?",
      paragraphs: [
        "LUKKEY का Kickstarter launch 2026 में planned है।",
        "सभी reservation holders को public launch से पहले early access और notification मिलेगा।",
      ],
    },
    faq8: {
      question: "LUKKEY किन assets को support करेगा?",
      paragraphs: [
        "LUKKEY 30+ blockchain networks और हजारों cryptocurrencies तथा NFT assets को support करता है।",
        "Users एक ही device पर cryptocurrencies और NFTs दोनों को सुरक्षित रूप से manage कर सकते हैं।",
        "और अधिक networks तथा assets firmware और app updates के ज़रिए लगातार जोड़े जाते रहेंगे।",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "और भी बहुत कुछ",
      ],
    },
  },
  mn: {
    faq1: {
      question: "LUKKEY бусад hardware wallet-уудаас юугаараа ялгаатай вэ?",
      paragraphs: [
        "LUKKEY нь өндөр хамгаалалт болон өдөр тутмын хэрэглэхэд эвтэй байдлыг хослуулах зорилготой бүтээгдсэн.",
        "LUKKEY нь self-custody-г хүн бүрт илүү аюулгүй, илүү хялбар болгохыг зорьдог.",
      ],
      bullets: [
        "Түлхүүрийг өндөр түвшинд хамгаалах EAL6+ secure element chip",
        "Хурдан бөгөөд аюулгүй нэвтрэх fingerprint authentication",
        "Asset separation болон privacy-д зориулсан нэг төхөөрөмж дээрх гурван independent wallet",
        "Private key-г бүрэн offline байлгах cold-signing architecture",
      ],
    },
    faq2: {
      question: "LUKKEY нээлттэй эхтэй юу?",
      paragraphs: [
        "Тийм. LUKKEY нь нээлттэй эхтэй бөгөөд ингэснээр олон нийт кодыг шалгаж, бие даасан аюулгүй байдлын аудит хийх боломжтой.",
        "Бид hardware wallet нь ил тод, шалгаж баталгаажуулж болохуйц байх ёстой гэж үздэг бөгөөд нээлттэй эх нь тэр итгэлийн гол хэсэг юм.",
      ],
    },
    faq3: {
      question: "EAL6+ secure element ямар үүрэгтэй вэ?",
      paragraphs: [
        "EAL6+ secure element нь эмзэг криптографийн өгөгдлийг хамгаалахаар бүтээгдсэн тусгай chip юм.",
        "Энэ нь private key-г аюулгүй хадгалж, tamper-resistant орчинд криптографийн үйлдлүүдийг хийснээр таны хөрөнгийг физик болон дижитал халдлагаас хамгаална.",
        "Ийм түвшний security certification нь банкны карт, паспорт, өндөр хамгаалалттай төхөөрөмжүүдэд түгээмэл хэрэглэгддэг.",
      ],
    },
    faq4: {
      question:
        "Би нэг төхөөрөмж дээр гурван independent wallet үүсгэж болох уу?",
      paragraphs: [
        "Тийм.",
        "LUKKEY нь нэг төхөөрөмж дээр өөр өөр private key, recovery phrase бүхий гурван бүрэн independent wallet үүсгэх боломж олгоно.",
        "Wallet бүр бие даан, аюулгүй ажиллана.",
      ],
      bullets: [
        "Урт хугацааны хадгаламж болон өдөр тутмын хөрөнгийг тусгаарлах",
        "Өөр өөр portfolio удирдах",
        "Илүү privacy авахын тулд hidden эсвэл decoy wallet үүсгэх",
      ],
    },
    faq5: {
      question: "Хэрэв би төхөөрөмжөө алдвал яах вэ?",
      paragraphs: [
        "Таны crypto asset төхөөрөмж дээр биш, blockchain дээр хадгалагддаг.",
        "LUKKEY-г тохируулах үед та wallet-аа сэргээхэд ашиглах recovery phrase үүсгэнэ.",
        "LUKKEY нь мөн NFC backup card дэмждэг тул recovery мэдээллээ аюулгүй хадгалах илүү тохиромжтой арга өгдөг.",
        "Хэрэв төхөөрөмж алдагдсан эсвэл гэмтсэн бол recovery phrase эсвэл NFC backup card ашиглан wallet-аа сэргээж болно.",
        "Таны backup аюулгүй байвал таны funds ч аюулгүй байна.",
      ],
    },
    faq6: {
      question: "$1 reservation-д юу багтдаг вэ?",
      paragraphs: [
        "$1 reservation нь таны early-bird эрхийг баталгаажуулж, crowdfunding эхлэхээс өмнө priority list-д оруулна.",
        "Public launch-аас өмнө та эрт мэдэгдэл болон reservation-ийн бүх benefits-ийг хүлээн авна.",
      ],
      bullets: [
        "Early-bird үнээс $20 хямдрал",
        "Launch email-ийг хамгийн түрүүнд авч, crowdfunding page-д эрт нэвтрэх",
        "Priority shipping",
        "VIP community access",
        "Хязгаарлагдмал хувилбарын NFC backup card болон онцгой IP бэлэг",
      ],
    },
    faq7: {
      question: "LUKKEY хэзээ Kickstarter дээр гарах вэ?",
      paragraphs: [
        "LUKKEY 2026 онд Kickstarter дээр launch хийхээр төлөвлөж байна.",
        "Бүх reservation holder public launch-аас өмнө early access болон notification авна.",
      ],
    },
    faq8: {
      question: "LUKKEY ямар asset-уудыг дэмжих вэ?",
      paragraphs: [
        "LUKKEY нь 30+ blockchain network болон мянга мянган cryptocurrency, NFT asset-ийг дэмжинэ.",
        "Users нэг төхөөрөмж дээр cryptocurrency болон NFT-ээ аюулгүй удирдах боломжтой.",
        "Илүү олон network болон asset firmware, app update-аар үргэлжлэн нэмэгдэнэ.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "болон бусад олон",
      ],
    },
  },
  th: {
    faq1: {
      question: "อะไรทำให้ LUKKEY แตกต่างจาก hardware wallet อื่น ๆ?",
      paragraphs: [
        "LUKKEY ถูกออกแบบมาเพื่อผสานความปลอดภัยที่แข็งแกร่งเข้ากับความสะดวกในการใช้งานทุกวัน",
        "LUKKEY ต้องการทำให้ self-custody ปลอดภัยขึ้นและใช้งานง่ายขึ้นสำหรับทุกคน",
      ],
      bullets: [
        "ชิป secure element ระดับ EAL6+ สำหรับการปกป้องกุญแจขั้นสูง",
        "การยืนยันตัวตนด้วยลายนิ้วมือเพื่อการเข้าถึงที่รวดเร็วและปลอดภัย",
        "กระเป๋า 3 ชุดที่เป็นอิสระในอุปกรณ์เดียวเพื่อแยกสินทรัพย์และเพิ่มความเป็นส่วนตัว",
        "สถาปัตยกรรม cold signing เพื่อให้ private key ออฟไลน์อย่างสมบูรณ์",
      ],
    },
    faq2: {
      question: "LUKKEY เป็นโอเพนซอร์สหรือไม่?",
      paragraphs: [
        "ใช่ LUKKEY เป็นโอเพนซอร์ส ทำให้ชุมชนสามารถตรวจสอบโค้ดและทำการตรวจสอบความปลอดภัยอย่างอิสระได้",
        "เราเชื่อว่าฮาร์ดแวร์วอลเล็ตควรโปร่งใสและตรวจสอบได้ และโอเพนซอร์สคือส่วนสำคัญของการสร้างความไว้วางใจนั้น",
      ],
    },
    faq3: {
      question: "secure element EAL6+ ทำหน้าที่อะไร?",
      paragraphs: [
        "secure element EAL6+ คือชิปเฉพาะทางที่ออกแบบมาเพื่อปกป้องข้อมูลการเข้ารหัสที่ละเอียดอ่อน",
        "มันเก็บ private key ของคุณอย่างปลอดภัยและดำเนินการเข้ารหัสภายในสภาพแวดล้อมที่ป้องกันการงัดแงะ เพื่อปกป้องสินทรัพย์ของคุณจากการโจมตีทั้งทางกายภาพและดิจิทัล",
        "ระดับการรับรองด้านความปลอดภัยนี้มักพบในบัตรธนาคาร หนังสือเดินทาง และอุปกรณ์ที่มีความปลอดภัยสูง",
      ],
    },
    faq4: {
      question: "ฉันสามารถสร้างกระเป๋า 3 ชุดที่เป็นอิสระในอุปกรณ์เดียวได้หรือไม่?",
      paragraphs: [
        "ได้",
        "LUKKEY อนุญาตให้คุณสร้างกระเป๋าที่เป็นอิสระอย่างสมบูรณ์ 3 ชุดบนอุปกรณ์เดียว โดยแต่ละชุดมี private key และ recovery phrase ของตัวเอง",
        "แต่ละกระเป๋าจะทำงานอย่างเป็นอิสระและปลอดภัย",
      ],
      bullets: [
        "แยกเงินระยะยาวออกจากเงินใช้ประจำวัน",
        "จัดการพอร์ตการลงทุนที่แตกต่างกัน",
        "สร้างกระเป๋าที่ซ่อนอยู่หรือกระเป๋าหลอกเพื่อเพิ่มความเป็นส่วนตัว",
      ],
    },
    faq5: {
      question: "จะเกิดอะไรขึ้นหากฉันทำอุปกรณ์หาย?",
      paragraphs: [
        "สินทรัพย์คริปโตของคุณไม่ได้เก็บอยู่ในอุปกรณ์ แต่เก็บอยู่บนบล็อกเชน",
        "เมื่อคุณตั้งค่า LUKKEY คุณจะสร้าง recovery phrase เพื่อใช้กู้คืนกระเป๋าเงินของคุณ",
        "LUKKEY ยังรองรับ NFC backup card ซึ่งเป็นวิธีที่สะดวกในการเก็บข้อมูลการกู้คืนอย่างปลอดภัย",
        "หากอุปกรณ์ของคุณสูญหายหรือเสียหาย คุณสามารถกู้คืนกระเป๋าเงินได้ด้วย recovery phrase หรือ NFC backup card",
        "ตราบใดที่ backup ของคุณยังปลอดภัย เงินของคุณก็ยังปลอดภัย",
      ],
    },
    faq6: {
      question: "การจอง 1 ดอลลาร์รวมอะไรบ้าง?",
      paragraphs: [
        "การจอง 1 ดอลลาร์ช่วยล็อกสิทธิ์ early-bird ของคุณและทำให้คุณอยู่ในรายชื่อสำคัญก่อนการเปิดตัว crowdfunding",
        "ก่อนการเปิดตัวสู่สาธารณะ คุณจะได้รับการแจ้งเตือนล่วงหน้าและสิทธิประโยชน์การจองทั้งหมด",
      ],
      bullets: [
        "ส่วนลด 20 ดอลลาร์จากราคา early-bird",
        "ได้รับอีเมลเปิดตัวก่อนใครและเข้าถึงหน้าคราวด์ฟันดิงก่อนใคร",
        "การจัดส่งแบบลำดับความสำคัญ",
        "สิทธิ์เข้าถึงชุมชน VIP",
        "NFC backup card รุ่นลิมิเต็ดและของขวัญ IP สุดพิเศษ",
      ],
    },
    faq7: {
      question: "LUKKEY จะเปิดตัวบน Kickstarter เมื่อไร?",
      paragraphs: [
        "LUKKEY มีแผนจะเปิดตัวบน Kickstarter ในปี 2026",
        "ผู้ที่ทำการจองทุกคนจะได้รับ early access และการแจ้งเตือนก่อนการเปิดตัวสู่สาธารณะ",
      ],
    },
    faq8: {
      question: "LUKKEY จะรองรับสินทรัพย์ใดบ้าง?",
      paragraphs: [
        "LUKKEY รองรับเครือข่ายบล็อกเชนมากกว่า 30 เครือข่าย รวมถึงคริปโทเคอร์เรนซีและสินทรัพย์ NFT อีกหลายพันรายการ",
        "ผู้ใช้สามารถจัดการทั้งคริปโทเคอร์เรนซีและ NFT บนอุปกรณ์เดียวได้อย่างปลอดภัย",
        "เครือข่ายและสินทรัพย์เพิ่มเติมจะถูกเพิ่มเข้ามาอย่างต่อเนื่องผ่านการอัปเดตเฟิร์มแวร์และแอป",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "และอีกมากมาย",
      ],
    },
  },
  uk: {
    faq1: {
      question: "Чим LUKKEY відрізняється від інших апаратних гаманців?",
      paragraphs: [
        "LUKKEY розроблено так, щоб поєднати високий рівень безпеки зі зручністю щоденного використання.",
        "LUKKEY прагне зробити self-custody безпечнішим і простішим для кожного.",
      ],
      bullets: [
        "Чип secure element рівня EAL6+ для розширеного захисту ключів",
        "Автентифікація за відбитком пальця для швидкого й безпечного доступу",
        "Три незалежні гаманці на одному пристрої для розділення активів і кращої приватності",
        "Архітектура cold signing, що зберігає приватні ключі повністю офлайн",
      ],
    },
    faq2: {
      question: "LUKKEY має відкритий код?",
      paragraphs: [
        "Так. LUKKEY має відкритий код, тому спільнота може перевіряти його та проводити незалежні аудити безпеки.",
        "Ми вважаємо, що апаратний гаманець має бути прозорим і таким, що піддається перевірці, а відкритий код є ключовою частиною цієї довіри.",
      ],
    },
    faq3: {
      question: "Що робить secure element EAL6+?",
      paragraphs: [
        "Secure element EAL6+ — це спеціалізований чип, створений для захисту чутливих криптографічних даних.",
        "Він безпечно зберігає ваші приватні ключі та виконує криптографічні операції в середовищі, захищеному від втручання, захищаючи активи від фізичних і цифрових атак.",
        "Такий рівень сертифікації безпеки часто використовується в банківських картках, паспортах та високозахищених пристроях.",
      ],
    },
    faq4: {
      question: "Чи можу я створити три незалежні гаманці на одному пристрої?",
      paragraphs: [
        "Так.",
        "LUKKEY дозволяє створити на одному пристрої три повністю незалежні гаманці, кожен зі своїми приватними ключами та фразою відновлення.",
        "Кожен гаманець працює незалежно та безпечно.",
      ],
      bullets: [
        "Розділяти довгострокові активи та щоденні кошти",
        "Керувати різними портфелями",
        "Створювати приховані або приманкові гаманці для додаткової приватності",
      ],
    },
    faq5: {
      question: "Що станеться, якщо я загублю пристрій?",
      paragraphs: [
        "Ваші криптоактиви зберігаються не на пристрої, а в блокчейні.",
        "Під час налаштування LUKKEY ви створюєте фразу відновлення, яка використовується для відновлення гаманця.",
        "LUKKEY також підтримує NFC-картку резервного копіювання, що дає зручний спосіб безпечно зберігати інформацію для відновлення.",
        "Якщо пристрій буде втрачено або пошкоджено, ви зможете відновити гаманець за допомогою фрази відновлення або NFC-картки резервного копіювання.",
        "Поки резервна копія в безпеці, ваші кошти теж у безпеці.",
      ],
    },
    faq6: {
      question: "Що входить до резервування за 1 долар?",
      paragraphs: [
        "Резервування за 1 долар фіксує ваше право на early-bird умови та додає вас до пріоритетного списку перед запуском краудфандингу.",
        "До публічного запуску ви отримаєте завчасне сповіщення та всі переваги резервування.",
      ],
      bullets: [
        "Знижка 20 доларів від ціни early bird",
        "Раніше отримати лист про запуск і ранній доступ до сторінки краудфандингу",
        "Пріоритетна доставка",
        "Доступ до VIP-спільноти",
        "Лімітована NFC-картка резервного копіювання та ексклюзивний IP-подарунок",
      ],
    },
    faq7: {
      question: "Коли LUKKEY запуститься на Kickstarter?",
      paragraphs: [
        "Запуск LUKKEY на Kickstarter запланований на 2026 рік.",
        "Усі власники резервування отримають ранній доступ і сповіщення до публічного запуску.",
      ],
    },
    faq8: {
      question: "Які активи підтримуватиме LUKKEY?",
      paragraphs: [
        "LUKKEY підтримує понад 30 блокчейн-мереж і тисячі криптовалют та NFT-активів.",
        "Користувачі можуть безпечно керувати як криптовалютами, так і NFT на одному пристрої.",
        "Через оновлення прошивки та застосунку постійно додаватимуться нові мережі та активи.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "та багато інших",
      ],
    },
  },
  vi: {
    faq1: {
      question: "Điều gì khiến LUKKEY khác với các ví phần cứng khác?",
      paragraphs: [
        "LUKKEY được thiết kế để kết hợp khả năng bảo mật mạnh mẽ với sự tiện dụng hằng ngày.",
        "LUKKEY hướng tới việc giúp việc tự lưu ký trở nên an toàn hơn và dễ tiếp cận hơn cho mọi người.",
      ],
      bullets: [
        "Chip secure element EAL6+ để bảo vệ khóa ở mức nâng cao",
        "Xác thực vân tay để truy cập nhanh và an toàn",
        "Ba ví độc lập trên một thiết bị để tách biệt tài sản và tăng quyền riêng tư",
        "Kiến trúc cold signing để giữ private key luôn hoàn toàn ngoại tuyến",
      ],
    },
    faq2: {
      question: "LUKKEY có mã nguồn mở không?",
      paragraphs: [
        "Có. LUKKEY là mã nguồn mở, cho phép cộng đồng xem xét mã và thực hiện các cuộc kiểm toán bảo mật độc lập.",
        "Chúng tôi tin rằng một ví phần cứng phải minh bạch và có thể kiểm chứng, và mã nguồn mở là một phần cốt lõi để xây dựng niềm tin đó.",
      ],
    },
    faq3: {
      question: "Secure element EAL6+ có tác dụng gì?",
      paragraphs: [
        "Secure element EAL6+ là một con chip chuyên dụng được thiết kế để bảo vệ dữ liệu mật mã nhạy cảm.",
        "Nó lưu trữ private key của bạn một cách an toàn và thực hiện các phép toán mật mã bên trong môi trường chống can thiệp, giúp bảo vệ tài sản của bạn khỏi các cuộc tấn công vật lý và kỹ thuật số.",
        "Mức chứng nhận bảo mật này thường được sử dụng trong thẻ ngân hàng, hộ chiếu và các thiết bị có độ bảo mật cao.",
      ],
    },
    faq4: {
      question: "Tôi có thể tạo ba ví độc lập trên một thiết bị không?",
      paragraphs: [
        "Có.",
        "LUKKEY cho phép bạn tạo ba ví hoàn toàn độc lập trên cùng một thiết bị, mỗi ví có private key và cụm từ khôi phục riêng.",
        "Mỗi ví hoạt động độc lập và an toàn.",
      ],
      bullets: [
        "Tách khoản nắm giữ dài hạn khỏi tiền dùng hằng ngày",
        "Quản lý các danh mục đầu tư khác nhau",
        "Tạo ví ẩn hoặc ví mồi nhử để tăng thêm quyền riêng tư",
      ],
    },
    faq5: {
      question: "Điều gì xảy ra nếu tôi làm mất thiết bị?",
      paragraphs: [
        "Tài sản crypto của bạn không được lưu trên thiết bị mà trên blockchain.",
        "Khi thiết lập LUKKEY, bạn sẽ tạo một cụm từ khôi phục để dùng cho việc khôi phục ví.",
        "LUKKEY cũng hỗ trợ thẻ sao lưu NFC, mang đến cách thuận tiện để lưu trữ an toàn thông tin khôi phục của bạn.",
        "Nếu thiết bị bị mất hoặc hỏng, bạn có thể khôi phục ví bằng cụm từ khôi phục hoặc thẻ sao lưu NFC.",
        "Miễn là bản sao lưu của bạn an toàn, tài sản của bạn vẫn an toàn.",
      ],
    },
    faq6: {
      question: "Đặt chỗ 1 USD bao gồm những gì?",
      paragraphs: [
        "Khoản đặt chỗ 1 USD giúp bạn giữ quyền nhận ưu đãi early-bird và đưa bạn vào danh sách ưu tiên trước khi chiến dịch crowdfunding bắt đầu.",
        "Trước khi mở bán công khai, bạn sẽ nhận được thông báo sớm và đầy đủ các quyền lợi của việc đặt chỗ.",
      ],
      bullets: [
        "Giảm 20 USD so với giá early-bird",
        "Nhận email ra mắt đầu tiên và quyền truy cập sớm vào trang crowdfunding",
        "Giao hàng ưu tiên",
        "Quyền truy cập cộng đồng VIP",
        "Thẻ sao lưu NFC phiên bản giới hạn và quà tặng IP độc quyền",
      ],
    },
    faq7: {
      question: "Khi nào LUKKEY sẽ ra mắt trên Kickstarter?",
      paragraphs: [
        "LUKKEY dự kiến ra mắt trên Kickstarter vào năm 2026.",
        "Tất cả những người đã đặt chỗ sẽ nhận được quyền truy cập sớm và thông báo trước khi mở bán công khai.",
      ],
    },
    faq8: {
      question: "LUKKEY sẽ hỗ trợ những tài sản nào?",
      paragraphs: [
        "LUKKEY hỗ trợ hơn 30 mạng blockchain cùng hàng nghìn loại tiền mã hóa và tài sản NFT.",
        "Người dùng có thể quản lý an toàn cả tiền mã hóa và NFT trên cùng một thiết bị.",
        "Nhiều mạng và tài sản khác sẽ tiếp tục được bổ sung thông qua các bản cập nhật firmware và ứng dụng.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "và nhiều hơn nữa",
      ],
    },
  },
  id: {
    faq1: {
      question: "Apa yang membuat LUKKEY berbeda dari hardware wallet lain?",
      paragraphs: [
        "LUKKEY dirancang untuk menggabungkan keamanan yang kuat dengan kemudahan penggunaan sehari-hari.",
        "LUKKEY bertujuan membuat self-custody menjadi lebih aman dan lebih mudah bagi semua orang.",
      ],
      bullets: [
        "Chip secure element EAL6+ untuk perlindungan kunci tingkat lanjut",
        "Autentikasi sidik jari untuk akses yang cepat dan aman",
        "Tiga wallet independen dalam satu perangkat untuk pemisahan aset dan privasi",
        "Arsitektur cold signing untuk menjaga private key tetap sepenuhnya offline",
      ],
    },
    faq2: {
      question: "Apakah LUKKEY bersifat open source?",
      paragraphs: [
        "Ya. LUKKEY bersifat open source, sehingga komunitas dapat meninjau kode dan melakukan audit keamanan independen.",
        "Kami percaya hardware wallet harus transparan dan dapat diverifikasi, dan open source adalah bagian inti dari membangun kepercayaan tersebut.",
      ],
    },
    faq3: {
      question: "Apa fungsi secure element EAL6+?",
      paragraphs: [
        "Secure element EAL6+ adalah chip khusus yang dirancang untuk melindungi data kriptografi yang sensitif.",
        "Chip ini menyimpan private key Anda dengan aman dan menjalankan operasi kriptografi di dalam lingkungan yang tahan terhadap perusakan, sehingga melindungi aset Anda dari serangan fisik maupun digital.",
        "Tingkat sertifikasi keamanan seperti ini umum digunakan pada kartu bank, paspor, dan perangkat dengan keamanan tinggi.",
      ],
    },
    faq4: {
      question: "Apakah saya bisa membuat tiga wallet independen di satu perangkat?",
      paragraphs: [
        "Ya.",
        "LUKKEY memungkinkan Anda membuat tiga wallet yang sepenuhnya independen di satu perangkat, masing-masing dengan private key dan recovery phrase-nya sendiri.",
        "Setiap wallet beroperasi secara independen dan aman.",
      ],
      bullets: [
        "Memisahkan dana jangka panjang dan dana harian",
        "Mengelola portofolio yang berbeda",
        "Membuat wallet tersembunyi atau wallet umpan untuk privasi tambahan",
      ],
    },
    faq5: {
      question: "Apa yang terjadi jika saya kehilangan perangkat?",
      paragraphs: [
        "Aset kripto Anda tidak disimpan di perangkat, melainkan di blockchain.",
        "Saat menyiapkan LUKKEY, Anda akan membuat recovery phrase yang digunakan untuk memulihkan wallet Anda.",
        "LUKKEY juga mendukung kartu backup NFC, yang memberikan cara praktis untuk menyimpan informasi pemulihan Anda dengan aman.",
        "Jika perangkat Anda hilang atau rusak, Anda dapat memulihkan wallet menggunakan recovery phrase atau kartu backup NFC.",
        "Selama backup Anda aman, dana Anda tetap aman.",
      ],
    },
    faq6: {
      question: "Apa saja yang termasuk dalam reservasi US$1?",
      paragraphs: [
        "Reservasi US$1 mengamankan kelayakan early-bird Anda dan menempatkan Anda di daftar prioritas sebelum peluncuran crowdfunding.",
        "Sebelum peluncuran publik, Anda akan menerima pemberitahuan lebih awal dan semua manfaat reservasi.",
      ],
      bullets: [
        "Diskon US$20 dari harga early-bird",
        "Menerima email peluncuran lebih dulu dan akses awal ke halaman crowdfunding",
        "Pengiriman prioritas",
        "Akses ke komunitas VIP",
        "Kartu backup NFC edisi terbatas dan hadiah IP eksklusif",
      ],
    },
    faq7: {
      question: "Kapan LUKKEY akan diluncurkan di Kickstarter?",
      paragraphs: [
        "LUKKEY direncanakan akan diluncurkan di Kickstarter pada tahun 2026.",
        "Semua pemegang reservasi akan menerima akses awal dan pemberitahuan sebelum peluncuran publik.",
      ],
    },
    faq8: {
      question: "Aset apa saja yang akan didukung oleh LUKKEY?",
      paragraphs: [
        "LUKKEY mendukung 30+ jaringan blockchain serta ribuan aset kripto dan NFT.",
        "Pengguna dapat mengelola kripto maupun NFT dengan aman di satu perangkat.",
        "Lebih banyak jaringan dan aset akan terus ditambahkan melalui pembaruan firmware dan aplikasi.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "dan banyak lagi",
      ],
    },
  },
  tl: {
    faq1: {
      question:
        "Ano ang nagpapakaiba sa LUKKEY kumpara sa ibang hardware wallets?",
      paragraphs: [
        "Idinisenyo ang LUKKEY upang pagsamahin ang matibay na seguridad at madaling gamitin sa araw-araw.",
        "Layunin ng LUKKEY na gawing mas ligtas at mas madali ang self-custody para sa lahat.",
      ],
      bullets: [
        "EAL6+ secure element chip para sa mas advanced na proteksyon ng susi",
        "Fingerprint authentication para sa mabilis at ligtas na access",
        "Tatlong independent wallet sa iisang device para sa asset separation at privacy",
        "Cold-signing architecture para mapanatiling ganap na offline ang private keys",
      ],
    },
    faq2: {
      question: "Open source ba ang LUKKEY?",
      paragraphs: [
        "Oo. Open source ang LUKKEY, kaya maaaring suriin ng komunidad ang code at magsagawa ng independent security audits.",
        "Naniniwala kami na ang isang hardware wallet ay dapat malinaw at mabeberipika, at ang open source ay mahalagang bahagi ng pagbuo ng tiwalang iyon.",
      ],
    },
    faq3: {
      question: "Ano ang ginagawa ng EAL6+ secure element?",
      paragraphs: [
        "Ang EAL6+ secure element ay isang espesyal na chip na idinisenyo upang protektahan ang sensitibong cryptographic data.",
        "Ligtas nitong iniimbak ang iyong private keys at isinasagawa ang cryptographic operations sa loob ng isang tamper-resistant na kapaligiran, upang maprotektahan ang iyong mga asset laban sa pisikal at digital na pag-atake.",
        "Karaniwang ginagamit ang ganitong antas ng security certification sa mga bank card, pasaporte, at mga high-security device.",
      ],
    },
    faq4: {
      question:
        "Maaari ba akong gumawa ng tatlong independent wallet sa iisang device?",
      paragraphs: [
        "Oo.",
        "Pinapayagan ka ng LUKKEY na gumawa ng tatlong ganap na independent wallet sa iisang device, bawat isa ay may sariling private keys at recovery phrase.",
        "Ang bawat wallet ay gumagana nang hiwalay at ligtas.",
      ],
      bullets: [
        "Ihiwalay ang long-term holdings at daily funds",
        "Pamahalaan ang iba't ibang portfolio",
        "Gumawa ng hidden o decoy wallets para sa dagdag na privacy",
      ],
    },
    faq5: {
      question: "Ano ang mangyayari kung mawala ko ang device?",
      paragraphs: [
        "Ang iyong mga crypto asset ay hindi nakaimbak sa device, kundi nasa blockchain.",
        "Kapag sini-set up ang LUKKEY, bubuo ka ng recovery phrase na gagamitin upang maibalik ang iyong wallet.",
        "Sinusuportahan din ng LUKKEY ang NFC backup card, na nagbibigay ng maginhawang paraan upang ligtas na maiimbak ang iyong impormasyon sa recovery.",
        "Kung mawala o masira ang iyong device, maaari mong maibalik ang iyong wallet gamit ang recovery phrase o NFC backup card.",
        "Hangga't ligtas ang iyong backup, ligtas din ang iyong pondo.",
      ],
    },
    faq6: {
      question: "Ano ang kasama sa $1 reservation?",
      paragraphs: [
        "Tinitiyak ng $1 reservation ang iyong early-bird eligibility at inilalagay ka sa priority list bago ang crowdfunding launch.",
        "Bago ang public launch, makakatanggap ka ng maagang abiso at lahat ng reservation benefits.",
      ],
      bullets: [
        "$20 off sa early-bird price",
        "Maunang makatanggap ng launch email at early access sa crowdfunding page",
        "Priority shipping",
        "Access sa VIP community",
        "Limited-edition NFC backup card at exclusive IP gift",
      ],
    },
    faq7: {
      question: "Kailan ilulunsad ang LUKKEY sa Kickstarter?",
      paragraphs: [
        "Plano ang LUKKEY na ilunsad sa Kickstarter sa 2026.",
        "Lahat ng may reservation ay makakatanggap ng early access at abiso bago ang public launch.",
      ],
    },
    faq8: {
      question: "Anong mga asset ang susuportahan ng LUKKEY?",
      paragraphs: [
        "Sinusuportahan ng LUKKEY ang mahigit 30 blockchain network at libu-libong cryptocurrency at NFT asset.",
        "Maaaring ligtas na pamahalaan ng mga user ang parehong cryptocurrency at NFT sa iisang device.",
        "Mas marami pang network at asset ang patuloy na idaragdag sa pamamagitan ng firmware at app updates.",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "at marami pang iba",
      ],
    },
  },
  bn: {
    faq1: {
      question: "LUKKEY-কে অন্য hardware wallet থেকে কী আলাদা করে?",
      paragraphs: [
        "LUKKEY এমনভাবে ডিজাইন করা হয়েছে যাতে শক্তিশালী নিরাপত্তা এবং দৈনন্দিন ব্যবহারযোগ্যতা একসাথে পাওয়া যায়।",
        "LUKKEY-এর লক্ষ্য হলো self-custody-কে সবার জন্য আরও নিরাপদ এবং আরও সহজ করা।",
      ],
      bullets: [
        "উন্নত key protection-এর জন্য EAL6+ secure element chip",
        "দ্রুত ও নিরাপদ access-এর জন্য fingerprint authentication",
        "Asset separation এবং privacy-এর জন্য এক ডিভাইসে তিনটি independent wallet",
        "Private key সম্পূর্ণ offline রাখার জন্য cold-signing architecture",
      ],
    },
    faq2: {
      question: "LUKKEY কি ওপেন সোর্স?",
      paragraphs: [
        "হ্যাঁ। LUKKEY ওপেন সোর্স, তাই কমিউনিটি কোড পর্যালোচনা করতে পারে এবং স্বাধীন নিরাপত্তা অডিট পরিচালনা করতে পারে।",
        "আমরা মনে করি একটি হার্ডওয়্যার ওয়ালেট স্বচ্ছ এবং যাচাইযোগ্য হওয়া উচিত, আর ওপেন সোর্স সেই বিশ্বাস তৈরির একটি মূল অংশ।",
      ],
    },
    faq3: {
      question: "EAL6+ secure element কী কাজ করে?",
      paragraphs: [
        "EAL6+ secure element হলো একটি বিশেষ chip যা সংবেদনশীল cryptographic data রক্ষা করার জন্য তৈরি করা হয়েছে।",
        "এটি আপনার private key নিরাপদে সংরক্ষণ করে এবং tamper-resistant environment-এর মধ্যে cryptographic operation সম্পাদন করে, যাতে আপনার asset physical এবং digital attack থেকে সুরক্ষিত থাকে।",
        "এই স্তরের security certification সাধারণত bank card, passport এবং high-security device-এ ব্যবহৃত হয়।",
      ],
    },
    faq4: {
      question:
        "আমি কি এক ডিভাইসে তিনটি independent wallet তৈরি করতে পারি?",
      paragraphs: [
        "হ্যাঁ।",
        "LUKKEY আপনাকে এক ডিভাইসে তিনটি সম্পূর্ণ independent wallet তৈরি করতে দেয়, প্রতিটির নিজস্ব private key এবং recovery phrase রয়েছে।",
        "প্রতিটি wallet স্বাধীনভাবে এবং নিরাপদে কাজ করে।",
      ],
      bullets: [
        "দীর্ঘমেয়াদি holdings এবং দৈনন্দিন funds আলাদা রাখা",
        "ভিন্ন portfolio পরিচালনা করা",
        "অতিরিক্ত privacy-এর জন্য hidden বা decoy wallet তৈরি করা",
      ],
    },
    faq5: {
      question: "আমি যদি ডিভাইস হারিয়ে ফেলি তাহলে কী হবে?",
      paragraphs: [
        "আপনার crypto asset ডিভাইসে নয়, blockchain-এ সংরক্ষিত থাকে।",
        "LUKKEY সেটআপ করার সময় আপনি একটি recovery phrase তৈরি করবেন যা wallet restore করতে ব্যবহৃত হয়।",
        "LUKKEY NFC backup card-ও support করে, যা আপনার recovery information নিরাপদে সংরক্ষণের আরও সুবিধাজনক উপায় দেয়।",
        "যদি ডিভাইস হারিয়ে যায় বা ক্ষতিগ্রস্ত হয়, আপনি recovery phrase বা NFC backup card দিয়ে wallet restore করতে পারবেন।",
        "যতক্ষণ আপনার backup নিরাপদ, ততক্ষণ আপনার funds-ও নিরাপদ থাকবে।",
      ],
    },
    faq6: {
      question: "$1 reservation-এ কী কী অন্তর্ভুক্ত আছে?",
      paragraphs: [
        "$1 reservation আপনার early-bird eligibility নিশ্চিত করে এবং crowdfunding launch-এর আগে আপনাকে priority list-এ রাখে।",
        "Public launch-এর আগে আপনি early notification এবং reservation-এর সব সুবিধা পাবেন।",
      ],
      bullets: [
        "Early-bird price থেকে $20 ছাড়",
        "Launch email সবার আগে পাওয়া এবং crowdfunding page-এ early access",
        "Priority shipping",
        "VIP community access",
        "Limited-edition NFC backup card এবং exclusive IP gift",
      ],
    },
    faq7: {
      question: "LUKKEY কখন Kickstarter-এ launch হবে?",
      paragraphs: [
        "LUKKEY-এর Kickstarter launch 2026 সালে পরিকল্পিত।",
        "সব reservation holder public launch-এর আগে early access এবং notification পাবে।",
      ],
    },
    faq8: {
      question: "LUKKEY কোন কোন asset support করবে?",
      paragraphs: [
        "LUKKEY 30+ blockchain network এবং হাজার হাজার cryptocurrency ও NFT asset support করে।",
        "User-রা এক ডিভাইসে নিরাপদে cryptocurrency এবং NFT দুটোই manage করতে পারবেন।",
        "Firmware এবং app update-এর মাধ্যমে আরও network এবং asset যোগ হতে থাকবে।",
      ],
      bullets: [
        "Bitcoin (BTC)",
        "Ethereum (ETH)",
        "USDT",
        "BNB Chain",
        "TRON",
        "Polygon",
        "এবং আরও অনেক",
      ],
    },
  },
};

export const lukkeyFaqOverrides = Object.fromEntries(
  Object.entries(faqLocales).map(([locale, faqs]) => [
    locale,
    flattenFaqLocale(faqs),
  ]),
);
